export const imageUploadModalTranslationJP = {
  ImageUploadModal: {
    title: '画像のメンテナンス',
    close: '閉じる',
    delete: '削除',
    current_image: '現在の画像',
    re_upload: '再アップロード',
    file_selection: 'ファイル選択',
    reflect: '反映',
    upload_confirmation: 'アップロード確認',
    warn_confirm_delete: '削除しますか？',
    warn_upload_file_format: '有効な画像ファイルを選択してください (jpg、png、webp、gif を使用できます)',
    warn_upload_min_size: '{0} x {1} サイズ以上のファイルにしてください',
    warn_upload_max_size: '{0} x {1} サイズ以下のファイルにしてください',
    warn_upload_filesize: '{0}MBサイズ以下のファイルにしてください',
  },
};
